<template>
  <div class="dialogOut">
     <div class="dialogIn">
        <div class="close"><i @click="$emit('close')" class="iconfont icon-guanbi"></i></div>
        <div class="con">
          <div class="con1">{{looking.Name}}</div>
          <div class="con5"><img @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" :src="wxcode" /></div>
          <div class="con6" :style="{fontSize: ewmSize + 'px'}">{{ewmText}}</div>
          <div class="con3" v-for="item in variable" v-if="item.codetest">{{item.codetest}}</div>
          <div class="con4 cf">
            <div class="fl" v-if="looking.collected" @click="$emit($emit('dealColFalse'))">取消收藏</div>
            <div class="fl" v-else @click="$emit('dealColTrue')">加入收藏</div>
            <div class="fl"><router-link :to="`/Detail?id=${looking.Id}&CatalogId=${looking.CatalogId}&title=${looking.Name}`">打开文件</router-link></div>
          </div>
        </div>
      </div> 
    </div>
</template>

<script>
var longPressTimer = null;
export default {
  props: ['looking' , 'variable','wxcode'],
  data () {
    return {
      longPress: false,
      ewmText: '',
      ewmSize: ''
    }
  },
  methods: {
    touchstart () {
       this.longPress = true;
      longPressTimer = setTimeout(() => {
       if (this.longPress)
      {
        this.$emit('saveCode');
        local.setItem('IndexWxcode',this.wxcode);
        this.longPress = false;
      }

      }, 300);
    },
    touchmove () {
      this.longPress = false;
      clearTimeout(longPressTimer);
    },
    touchend () {
      clearTimeout(longPressTimer);
    },
  }
}
</script>

<style lang="less" scoped>
  .dialogOut{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0,0,0,.6);
    z-index: 1000;
    .dialogIn{
      position: absolute;
      width: 60%;
      top: 20%;
      left: 20%;
      background: white;
      padding: 0.26666666666666666rem;
      border-radius: 5px;
      .info{
        text-align: center;
        background: rgba(192,192,192,.6);
        position: absolute;
        left: 10%;
        width: 80%;
        padding: 5px;
        bottom: 0.5333333333333333rem;
      }
      .close{
        text-align: right;
      }
      .con{
        text-align: center;
        .con1{
          margin-bottom: 20px;
          margin-top: 0.5333333333333333rem;
          padding: 0 0.6666666666666666rem;
          color: #1e6ee7;
          font-size: 0.4266666666666667rem;
          white-space:nowrap;overflow:hidden;text-overflow:ellipsis; 
        }
        .con2{
          color: #99B2D8;
          margin-bottom: 0.8rem;
        }
        .con3{
          margin: 0.26666666666666666rem 0 0.5333333333333333rem 0;
          font-size: 0.37333333333333335rem;
          padding: 0 0.5333333333333333rem;
          text-align: center;
        }
        .con4{
          color: #6699CC;
          border-top: 1px dotted #d4d4d4;
          padding: 15px 0 10px 0;
          div{
            text-decoration: underline;
            text-align: center;
            width: 50%;
            color: #5e6f9b;
          }
        }
        .con5 img{
          width: 70%;
        }
        .con6{
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialog.vue